'use strict';

var React = require('react');

const RowContext = React.createContext({});
var RowContext$1 = RowContext;

module.exports = RowContext$1;
